module.exports = __webpack_public_path__ + "img/banner.2266d6c6.png";